import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { CarouselNavigationButtonPropertiesType, CarouselNavigationPropertiesType } from "@website/ui/carousel/carousel.types";
import { useEffect } from "react";
const SliderButton = t0 => {
  const $ = _c(9);
  const {
    icon,
    onClick,
    disabled,
    classes
  } = t0;
  const t1 = `bg-on-surface-high-emphasis z-1 absolute bottom-1/2 size-9 translate-y-1/2 transform-gpu rounded-full px-1.5 py-0.5 opacity-0 transition group-hover:opacity-100 ${classes} ${disabled ? "hidden" : ""}`;
  let t2;
  if ($[0] !== onClick) {
    t2 = event => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    };
    $[0] = onClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon) {
    t3 = <MaterialIcon name={icon} />;
    $[2] = icon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== disabled || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <button className={t1} disabled={disabled} onClick={t2} type="button">{t3}</button>;
    $[4] = disabled;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const CarouselNavigation = t0 => {
  const $ = _c(20);
  const {
    currentSlide,
    currentReference,
    rightBtnClassName,
    leftBtnClassName,
    hasNavigation,
    disableArrowKeys
  } = t0;
  let t1;
  let t2;
  if ($[0] !== currentReference || $[1] !== disableArrowKeys) {
    t1 = () => {
      if (!disableArrowKeys) {
        const listener = event => {
          if (event.key === "ArrowRight") {
            currentReference?.prev();
          }
          if (event.key === "ArrowLeft") {
            currentReference?.next();
          }
        };
        document.addEventListener("keydown", listener);
        return () => document.removeEventListener("keydown", listener);
      }
    };
    t2 = [currentReference, disableArrowKeys];
    $[0] = currentReference;
    $[1] = disableArrowKeys;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = `${hasNavigation === "fixed" ? "" : "max-lg:hidden"} text-on-color-high-emphasis text-2xl hover:block`;
  const t4 = `${rightBtnClassName} ${hasNavigation === "fixed" ? "opacity-100 lg:opacity-0" : ""} -right-4`;
  const t5 = currentSlide === 0;
  let t6;
  if ($[4] !== currentReference) {
    t6 = () => currentReference?.prev();
    $[4] = currentReference;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <SliderButton classes={t4} disabled={t5} icon="chevron_right" onClick={t6} />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${leftBtnClassName} ${hasNavigation === "fixed" ? "opacity-100 lg:opacity-0" : ""} -left-4`;
  const t9 = currentSlide === currentReference?.track?.details?.maxIdx;
  let t10;
  if ($[10] !== currentReference) {
    t10 = () => currentReference?.next();
    $[10] = currentReference;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t8 || $[14] !== t9) {
    t11 = <SliderButton classes={t8} disabled={t9} icon="chevron_left" onClick={t10} />;
    $[12] = t10;
    $[13] = t8;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t3 || $[18] !== t7) {
    t12 = <div className={t3}>{t7}{t11}</div>;
    $[16] = t11;
    $[17] = t3;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};